import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Store from './Redux/Store/Store';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import theme from './Theme'; 
import ToastProvider from './components/Common/Toaster/ToasterSetting';
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={Store}>
      <ToastProvider/>
      <BrowserRouter>
      <App />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
